import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { allLeadMode, asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Optimum,
  Astound,
  WOW,
  TDS,
  BuckeyeBroadband,
  Mediacom,
} from 'config/providers';
import { XfinityTheme } from 'config/themes';

// Origin - https://updater.atlassian.net/browse/COREX-991
export const LLMXfinityPartner: SingleProviderConfig = {
  name: 'LLMXfinityPartner',
  micrositeCode: 'LLMXfinityAd',
  mainProvider: Comcast,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'xfinityspecial.com',
  homepage: 'https://xfinityspecial.com/deals',
  title: 'Xfinity Authorized Dealer',
  fallbackPhoneNumber: '855-557-3918',
  fallbackLeadModePhoneNumber: '855-557-3915',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: XfinityTheme,
  needsDcSession: false,
  source: 'Xfinity',
  noOffersRetry: 2,
  commercialHomepage: 'https://comcastbusinessspecial.com',
  getCrossSellAction: getDefaultCrossSellAction,
  crossSellProviders: [
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Astound,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: false,
  getCheckoutType: asyncEligible,
};
